//
import { Categoria } from '../../shared/entity/Categoria';
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import colors from '../../colors';
import Title from '../Generic/Title';
import Touchable from '../Generic/Touchable';
import ItemProduto from './ItemProduto';
import { useIsBigScreen } from '../../helper';

type Props = {
  categoria: Categoria;
  goToProduto: (id: number) => void;
};

const ItemCategoria: React.FC<Props> = (props) => {
  const { categoria, goToProduto } = props;
  const [fechado, setFechado] = useState(true);

  const selecionarIcone = () => {
    if (fechado) {
      return <MaterialIcons name="add" size={24} color={colors.primary} />;
    }
    return <MaterialCommunityIcons name="minus" size={24} color={colors.primary} />;
  };

  if (!categoria.produtos || categoria.produtos.length === 0) {
    return null;
  }
  return (
    <View style={styles.container}>
      <Touchable onPress={() => setFechado(!fechado)} style={styles.button}>
        <Title>{categoria.descricao}</Title>
        {selecionarIcone()}
      </Touchable>
      <Collapsible collapsed={fechado}>
        {categoria.produtos.map((produto, i) => (
          <ItemProduto
            produto={produto}
            goToProduto={goToProduto}
            key={produto.id}
            hideDivider={i === categoria.produtos.length - 1}
          />
        ))}
      </Collapsible>
    </View>
  );
};

const styles = StyleSheet.create({
  button: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    // backgroundColor: '#ff0',
    paddingTop: 10,
    paddingBottom: 10
  },
  container: {
    backgroundColor: '#fff',
    width: '100%',
    marginBottom: 15
  }
});

export default ItemCategoria;
